import { render, staticRenderFns } from "./ProjectTablePartenaires.vue?vue&type=template&id=3a52642d&"
import script from "./ProjectTablePartenaires.vue?vue&type=script&lang=js&"
export * from "./ProjectTablePartenaires.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTablePartenaires.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports